import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Box, Button } from '@material-ui/core';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'dva';
import { useForm, FormProvider } from 'react-hook-form';
import { history, useIntl } from 'umi';
import AddStyled from './AddStyled';
import BasicInfo from './basicInfo/BasicInfo';
import CampaignEquity from './campaignEquity/CampaignEquity';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import webStorage from '@/utils/storageManager';
import Notice from './notice/Noticed';

const Add = () => {
  //国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const methods = useForm();
  const dispatch = useDispatch();
  const tenantId = webStorage.get('TENANT_ID');
  const saveRef = useRef();
  const { handleSubmit, control, register, errors, setValue, getValues } =
    useForm({});
  //获取参数
  const {
    opt: status,
    cardType,
    id,
    sourceOid,
  } = history?.location?.query || {};
  //编辑时拿到当前数据详情
  const activityGroupDetail =
    useSelector((state) => state.crowdAdd?.activityInfo) || [];

  //用户选择优惠券信息
  const [couponList, setCouponList] = useState([]);
  //关于导入手机号时关于相关文件信息
  const [fileInfo, setFileInfo] = useState();
  //关于导入手机号校验
  const [fileValidate, setFileValidate] = useState({});
  //关于时间校验

  const [selectedNoticeChannels, setSelectedNoticeChannels] = useState([]);
  //客户类型
  const [consumer, setConsumer] = useState('');

  //控制重复点击提交按钮
  const [isSubmit, setIsSubmit] = useState(false);
  //非新增模式获取活动相关信息
  const fetchActivityInfo = useCallback(() => {
    if (status !== 'add') {
      if (id) {
        dispatch({
          type: 'crowdAdd/getActivityInfo',
          payload: {
            values: {
              id,
            },
          },
        });
      }
    }
  }, [dispatch, id, status]);
  useEffect(() => {
    fetchActivityInfo();
  }, [fetchActivityInfo]);

  //获取用户的人数
  const fetchUserGroup = useCallback(() => {
    dispatch({
      type: 'crowdAdd/getUserGroupList',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);
  //获取用户的人数
  const getQueryGroupInfo = useCallback(() => {
    if (consumer) {
      dispatch({
        type: 'crowdAdd/getQueryGroupInfo',
        payload: {
          values: {
            groupId: consumer,
          },
        },
      });
    }
  }, [dispatch, consumer]);
  useEffect(() => {
    fetchUserGroup();
  }, [fetchUserGroup]);
  useEffect(() => {
    getQueryGroupInfo();
  }, [getQueryGroupInfo]);
  useEffect(() => {
    switch (cardType) {
      case 'REGISTERED_UNPAID':
        return setConsumer(1);
      case 'KEY_RECALL':
        return setConsumer(2);
      case 'CUSTOM_CROWD ':
        return setConsumer();
      default:
        return;
    }
  }, [cardType]);
  //获取活动执行周期类型
  const fetchCycleTypeList = useCallback(() => {
    dispatch({
      type: 'crowdAdd/getCycleTypeList',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);
  useEffect(() => {
    fetchCycleTypeList();
  }, [fetchCycleTypeList]);
  //编辑状态进来
  useEffect(() => {
    if (status !== 'add') {
      setConsumer(activityGroupDetail?.groupId);
      setFileInfo({
        fileName: activityGroupDetail?.fileName,
        filePath: activityGroupDetail?.filePath,
        downloadUrl: activityGroupDetail?.downloadUrl,
      });
      if (activityGroupDetail?.executeType === 'EXECUTE_TIMING') {
        setTimeout(() => setValue('executeType', 'EXECUTE_TIMING'));
        // setValue('beginTime', activityGroupDetail?.beginTime);
      } else {
        // setValue('cycleTime', activityGroupDetail?.beginTime);
        setTimeout(() => setValue('executeType', 'EXECUTE_IMMEDIATELY'));
      }
      // setValue('isCouponDelivery', activityGroupDetail?.isCouponDelivery);
      setValue('title', activityGroupDetail?.title);
      setValue('noticeType', activityGroupDetail?.noticeType);
      setCouponList(activityGroupDetail?.coupons);
      const newArray = activityGroupDetail?.noticeChannels?.map((i) => {
        return {
          ...i,
          checked: true,
        };
      });
      setSelectedNoticeChannels(newArray);
      setValue('isCouponDelivery', activityGroupDetail?.isCouponDelivery);
    }
  }, [status, activityGroupDetail, setValue]);
  //关于新增人群
  const handleSubmitSuccess = (data) => {
    if (isSubmit) {
      return false;
    }
    setIsSubmit(true);
    let time;
    if (data.executeType === 'EXECUTE_TIMING') {
      time = dayjs(data.beginTime).format('YYYY-MM-DD HH:mm:ss');
    } else if (data.dateType === 'CYCLE') {
      time = dayjs(data.cycleTime).format('HH:mm:00');
    }
    if (cardType === 'ASSIGN_TELEPHONE') {
      if (fileInfo?.code !== 0) {
        setFileValidate({
          type: 'FileTypeError',
          content: '请导入手机号文件',
        });
      }
    }
    let noticePriority = [
      {
        sortNo: 5,
        noticeMsgId: '',
        noticeChannelName: 'LINE 模版消息',
        noticeChannelType: '6',
      },
      {
        sortNo: 4,
        noticeMsgId: '',
        noticeChannelName: '彩信',
        noticeChannelType: '4',
      },
      {
        sortNo: 1,
        noticeMsgId: '',
        noticeChannelName: '微信模板消息',
        noticeChannelType: '2',
      },
      {
        sortNo: 2,
        noticeMsgId: '',
        noticeChannelName: '邮件',
        noticeChannelType: '5',
      },
      {
        sortNo: 3,
        noticeMsgId: '',
        noticeChannelName: '短信',
        noticeChannelType: '1',
      },
    ];
    const NoticeChannels = selectedNoticeChannels?.filter((i) => i.checked);
    if (data.isCouponDelivery === undefined) {
      data.isCouponDelivery = false;
    }
    let values = {
      ...data,
      id,
      type: cardType,
      beginTime: time,
      cycleTime: time,
      coupons: data.isCouponDelivery ? couponList : [],
      noticeChannels: NoticeChannels,
      groupId: consumer,
      noticePriority,
      cycleStartDate: data?.date?.startDate || null,
      cycleEndDate: data?.date?.endDate || null,
    };
    delete data.date;
    if (fileInfo) {
      values = {
        ...values,
        filePath: fileInfo?.filePath,
        fileName: fileInfo?.fileName,
      };
    }
    if (values.dateCycle === 'DAY') {
      values.dateDay = [1];
    }
    values.dateType === 'ONCE'
      ? delete values.cycleTime
      : delete values.beginTime;
    if (values.dateType === 'CYCLE') {
      values.executeType = 'EXECUTE_TIMING';
    }
    if (status === 'add') {
      dispatch({
        type: 'crowdAdd/addActivityGroup',
        payload: {
          values: values,
        },
        callback: (res) => {
          window.NE_DAWN.trigger(saveRef.current, {
            event: '_ec', // 事件名
            params: { ...values }, // 事件公参
          });
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '新增成功',
              title: '成功',
            });
            history.push('/marketing/crowd');
            return;
          }
          setIsSubmit(false);
        },
      });
    } else if (status === 'edit') {
      values = { ...values, id };
      dispatch({
        type: 'crowdAdd/updateActivityGroup',
        payload: {
          values: values,
        },
        callback: (res) => {
          window.NE_DAWN.trigger(saveRef.current, {
            event: '_ec', // 事件名
            params: { ...values }, // 事件公参
          });
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '编辑成功',
              title: '成功',
            });
            history.push('/marketing/crowd');
            dispatch({
              type: 'crowdAdd/save',
              payload: {
                activityInfo: [],
              },
            });
            return;
          }
          setIsSubmit(false);
        },
      });
    }
  };
  const handleSubmitFailed = (error) => {
    console.log(error, 'errors');
    // dispatch({
    //   type: 'crowdAdd/addActivityGroup',
    //   payload: {
    //     values: {},
    //   },
    // });
  };
  //关于退出
  const handleClickExit = () => {
    dispatch({
      type: 'crowdAdd/save',
      payload: {
        activityInfo: [],
      },
    });
    history.push('/marketing/crowd');
  };

  return (
    <AddStyled>
      <Box
        data-log={JSON.stringify({
          oid: 'page_marketing_activity_user_operation_edit',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
            source: sourceOid,
          },
          events: ['_pv', '_pd'],
        })}
        className="form-wrapper"
      >
        <FormProvider {...methods}>
          <form
            onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFailed)}
          >
            <BasicInfo
              getValues={getValues}
              consumer={consumer}
              setConsumer={setConsumer}
              cardType={cardType}
              status={status}
              control={control}
              fileInfo={fileInfo}
              fileValidate={fileValidate}
              setFileValidate={setFileValidate}
              setFileInfo={setFileInfo}
              register={register}
              errors={errors}
              setValue={setValue}
              activityGroupDetail={activityGroupDetail}
            />
            <CampaignEquity
              cardType={cardType}
              status={status}
              control={control}
              activityGroupDetail={activityGroupDetail}
              setValues={setValue}
              couponList={couponList}
              setCouponList={setCouponList}
              register={register}
              errors={errors}
            />
            <Notice
              tenantId={tenantId}
              status={status}
              control={control}
              register={register}
              errors={errors}
              activityGroupDetail={activityGroupDetail}
              setSelectedNoticeChannels={setSelectedNoticeChannels}
              selectedNoticeChannels={selectedNoticeChannels}
            />
            <Box className="button-group">
              {status !== 'detail' && (
                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_marketing_activity_user_operation_edit_finish',
                    events: ['_ev'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                      source: sourceOid,
                    },
                  })}
                  ref={saveRef}
                  variant="contained"
                  className="finish"
                  type="submit"
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  {formatMessage({ id: 'comm.action.btn.17' })}
                </Button>
              )}

              {/* {

              } */}
              {/* <Button variant="contained" color="secondary" className="reset">
                重置
              </Button> */}
              <Button
                variant="contained"
                color="secondary"
                className="exit"
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
                onClick={handleClickExit}
              >
                {formatMessage({ id: 'comm.action.btn.16' })}
              </Button>
            </Box>
          </form>
        </FormProvider>
      </Box>
    </AddStyled>
  );
};
export default Add;
